function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Warning symbol");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Ellipse_63",
  "data-name": "Ellipse 63"
}, React.createElement("circle", {
  className: "cls-1",
  cx: 15.5,
  cy: 15.5,
  r: 15.5
}), React.createElement("path", {
  className: "cls-2",
  fill: "#ffca1a",
  d: "M15.56,31.36a15.5,15.5,0,1,1,15.5-15.5A15.51,15.51,0,0,1,15.56,31.36Zm0-29a13.5,13.5,0,1,0,13.5,13.5A13.51,13.51,0,0,0,15.56,2.36Z",
  transform: "translate(-0.06 -0.36)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "_",
  "data-name": " ",
  className: "cls-3",
  fill: "#ffca1a"
}, React.createElement("g", {
  className: "cls-3"
}, React.createElement("path", {
  className: "cls-2",
  d: "M15.19,23.12a1.14,1.14,0,0,1-.35-.84,1.11,1.11,0,0,1,.34-.84,1.22,1.22,0,0,1,.88-.33,1.19,1.19,0,0,1,.85.33,1.11,1.11,0,0,1,.34.84,1.17,1.17,0,0,1-.34.84,1.14,1.14,0,0,1-.85.36A1.19,1.19,0,0,1,15.19,23.12Zm-.1-15.86H17l-.34,11.27H15.41Z",
  transform: "translate(-0.06 -0.36)"
})));

var SvgWarningIcon = function SvgWarningIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-icon.b812436b.svg";
export { ForwardRef as ReactComponent };